<template>
  <section class="exercise-chart" aria-label="Gráfico del ejercicio">
    <div v-if="resolutionKeys.length > 1" class="exercise-chart__timings" aria-label="Temporalidad">
      <button v-for="key in resolutionKeys" :key="key" type="button" :class="{ 'is-active': key === activeResolution }" @click="activeResolution = key">
        {{ resolutionLabel(key) }}
      </button>
    </div>
    <div v-if="!candles.length" class="exercise-chart__empty">No hay datos de gráfico para esta pregunta.</div>
    <highcharts v-else :constructor-type="'stockChart'" :options="options" class="exercise-chart__canvas" />
    <p v-if="candles.length" class="exercise-chart__hint">Toca una vela para seleccionarla. También puedes recorrer los puntos con el teclado del gráfico.</p>
  </section>
</template>

<script>
export default {
  name: 'ExerciseChart',
  props: {
    chart: { type: Object, default: () => ({}) },
    selectedDates: { type: Array, default: () => [] },
    ticker: { type: String, default: '' }
  },
  data() { return { activeResolution: '' }; },
  computed: {
    resolutionKeys() { return Object.keys(this.chart).filter(key => Array.isArray(this.chart[key]) && this.chart[key].length); },
    candles() { return this.chart[this.activeResolution] || []; },
    options() {
      const vm = this;
      return {
        chart: { height: 330, backgroundColor: 'transparent', spacing: [12, 6, 8, 6] },
        credits: { enabled: false },
        exporting: { enabled: false },
        navigator: { enabled: false },
        scrollbar: { enabled: false },
        rangeSelector: { enabled: false },
        title: { text: this.ticker || '', style: { color: 'var(--modern-text)', fontSize: '14px' } },
        xAxis: { type: 'datetime', labels: { style: { color: 'var(--modern-muted)' } } },
        yAxis: { opposite: false, title: { text: '' }, labels: { style: { color: 'var(--modern-muted)' } }, gridLineColor: 'var(--modern-border)' },
        tooltip: { split: false, shared: true },
        plotOptions: {
          series: {
            allowPointSelect: true,
            cursor: 'pointer',
            point: { events: { click() { vm.$emit('select-date', this.options.custom.date); } } },
            states: { select: { color: '#008db5', lineColor: '#006b8a' } }
          }
        },
        series: [{
          type: 'candlestick',
          name: this.ticker || 'Precio',
          data: this.candles.map(row => ({
            x: row.time,
            open: row.open,
            high: row.high,
            low: row.low,
            close: row.close,
            custom: { date: row.date },
            selected: this.selectedDates.includes(row.date)
          })),
          color: '#d9536f',
          upColor: '#36a779',
          lineColor: '#b63e59',
          upLineColor: '#27805d'
        }]
      };
    }
  },
  watch: {
    resolutionKeys: {
      immediate: true,
      handler(keys) {
        if (!keys.includes(this.activeResolution)) {
          this.activeResolution = keys.includes('month') ? 'month' : (keys[0] || '');
        }
      }
    }
  },
  methods: {
    resolutionLabel(key) {
      if (key === 'week' || key === '7') return 'Semanal';
      if (key === 'month' || key === '23') return 'Mensual';
      return key;
    }
  }
};
</script>

<style lang="scss" scoped>
.exercise-chart { min-width: 0; overflow: hidden; border: 1px solid var(--modern-border); border-radius: 16px; background: var(--modern-surface); }
.exercise-chart__timings { display: flex; gap: 6px; padding: 10px 10px 0; }
.exercise-chart__timings button { min-height: 40px; padding: 0 14px; border: 1px solid var(--modern-border); border-radius: 10px; background: transparent; color: var(--modern-muted); font: inherit; cursor: pointer; }
.exercise-chart__timings button.is-active { border-color: var(--modern-accent); background: var(--modern-accent-soft); color: var(--modern-accent); font-weight: 700; }
.exercise-chart__canvas { width: 100%; min-height: 330px; }
.exercise-chart__hint, .exercise-chart__empty { margin: 0; padding: 10px 14px 14px; color: var(--modern-muted); font-size: 12px; }
.exercise-chart__empty { display: grid; place-items: center; min-height: 220px; text-align: center; }
@media (max-width: 500px) { .exercise-chart__canvas { min-height: 285px; } }
</style>
